import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-invalid-modelations-dialog',
    templateUrl: './blacklist-dialog.component.html',
    imports: [MatDialogModule, MatButtonModule],
})
export class BlacklistDialogComponent {
    dialogRef = inject<MatDialogRef<BlacklistDialogComponent>>(MatDialogRef);
}
